// @flow

import * as React from 'react';

import { NonNavigableItem } from '@ta/list.navigable-list';

import styles from './SectionTitle.less';

type Props = {|
  title: string,
|};

/**
 * A simple section title for typeahead results.
 *
 * Note that this is intended to be used inside a <NavigableList/>
 */
const SectionTitle = ({ title }: Props) => <div className={styles.section}>{title}</div>;

// NavigableList should ignore this item
SectionTitle[NonNavigableItem] = true;

export default SectionTitle;
